import React from 'react';
import { cn } from '../../../utils/cn';

/**
 * Individual footer column component
 *
 * @param {Object} props
 * @param {string} props.title - Section title
 * @param {ReactNode} props.children - Section content
 * @param {string} props.className - Additional CSS classes
 */
export const FooterSection = ({ title, children, className }) => {
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {title && (
        <h3 className="text-lg font-bold text-white uppercase tracking-wide">
          {title}
        </h3>
      )}
      {children}
    </div>
  );
};
